import basicController from "servicestack/basic.controller.properties";
import ServiceBus from 'servicestack/service-bus'
import AutoQuery from "servicestack/auto-query/auto-query";

export default class TicketContainerController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
	$ctrl.tickets = [];
    $ctrl.bus = new ServiceBus();
  }

  $onInit() {
    const $ctrl = this;
    $ctrl.query = new AutoQuery($ctrl.getAutoQueryOptions());
  }

  getAutoQueryOptions() {
    const $ctrl = this;
    return {
      url: "QueryTickets.json",
      pageSize: $ctrl.$pageConfig.is("gt-sm") ? 12 : 6,
//      views: {
//        list: "th-list",
//        cards: "th"
//      },
      criteria: {
        assigned_email: $ctrl.$session.email
      },
      view: $ctrl.$pageConfig.is("gt-md") ? "list" : "cards",
      sortOptions: {
        "Id": "Ticket Id: Low to High",
        "-Id": "Ticket Id: High to Low",
        "Id": "Created Date: Oldest",
        "-Id": "Created Date: Newest",
			"Subject,Id": "Subject: A to Z",
			"-Subject,Id": "Subject: Z to A",
			"Description,Id": "Description: A to Z",
			"-Description,Id": "Description: Z to A",
			"Priority,Id": "Priority: Low to High",
			"-Priority,Id": "Priority: High to Low",
	  },
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      orderBy: "-CreatedAt",
      autoLoad: true,
      append: false
    };
  }
  load() {
    const $ctrl = this;
    return $ctrl.query.load.apply($ctrl.query, arguments);
  }


}
